module.exports = __webpack_public_path__ + "img/banner.c13fbb08.png";